import { PeopleBadgeList } from '@/routes/_layout/scheduling/student-groups/-components/people-badge-list.js';
import { hasPendingAutomaticConflictForOriginalTeacher } from '@airreading/common';
import { AdminSession, VideoConferenceType } from '@airreading/common/data';

interface OriginalTeacherDisplayProps {
  session: AdminSession;
  testId?: string;
}

export function isOriginalTeacherPendingSubstitute(session: AdminSession): boolean {
  return (
    session.videoConferenceType === VideoConferenceType.zoom && hasPendingAutomaticConflictForOriginalTeacher(session)
  );
}

export const OriginalTeacherDisplay = ({ session, testId }: OriginalTeacherDisplayProps) => {
  const { coach } = session;

  if (isOriginalTeacherPendingSubstitute(session)) {
    return <span data-testid={testId}>Pending substitute teacher</span>;
  }
  if (!coach) {
    return null;
  }
  return <PeopleBadgeList people={[coach]} testId={testId} />;
};
